import s from '../collegesItem.module.css'
import {useState} from "react";
import {Button} from "antd";
import {useAddAlert} from "@/hooks/useAddAlert";
import {directionGroupApi} from "@api"

import { InputNew } from "@UI/InputNew";
import { useInputNew } from "@UI/InputNew/useInputNew";

const ModalAddGroup = ({setActive, userId, update, direction}) => {
  const addAlert = useAddAlert();

  const [loading, setLoading] = useState(false);
  
  const [errorsList, setErrorsList] = useState([])
  const [showErrors, setShowErrors] = useState(false)

  const [name, setName] = useState('')
  const [bindName] = useInputNew({
    name: 'name',
    value: name,
    onChange: setName,
    onError: setErrorsList,
    placeholder: 'Введите название',
    validate: showErrors,
    errorText: 'Не задано название группы',
  })

  const modalSave = () => {
    setShowErrors(true)
    if (errorsList.valid) {
      setLoading(true);
      const data = {
        "direction_id": direction,
        "teacher_id": userId,
        "name": name,
      }
      directionGroupApi.add({ data })
      .then(res => {
        if (res?.data?.data?.id !== undefined){
            update("direction");
            addAlert({ title: "Группа успешно создана" });
            setActive(false);
        }
        else{
            alert('Ошибка создания группы')
        }
      })
      .finally((res)=>{
        setLoading(false);
      })

    }
  }

  return <div className="modal_departments">
    <h2 className="modal__title">Создание новой группы</h2>
    <div className={s.body}>
          <span style={{fontSize:'12px', color:'#000000e0', fontWeight:'400', marginBottom:'-10px'}}>Введите название группы</span>
          <InputNew style={{width:'100%'}} className={s.input} {...bindName} />
          <Button disabled={loading} onClick={modalSave}>Сохранить</Button>
    </div>
  </div>
}
export default ModalAddGroup;